import { createFeature, createReducer, on } from '@ngrx/store';
import { ProjectSurveyTaskServiceCreateResponseJson } from '@vmspdb/definitions';
import { PaginatedSurveyTaskActions } from './paginated-survey-task.actions';

export const paginatedSurveyTaskFeatureKey = 'paginatedSurveyTask';

export interface PaginatedSurveyTaskState {
  items: ProjectSurveyTaskServiceCreateResponseJson[];
  loading: boolean;
  total: number;
  page: number;
  error: any;
}

export const initialState: PaginatedSurveyTaskState = {
  items: [],
  total: 0,
  page: 0,
  loading: false,
  error: undefined,
};

export const reducer = createReducer(
  initialState,
  on(
    PaginatedSurveyTaskActions.listPaginatedSurveyTasks,
    (state): PaginatedSurveyTaskState => ({ ...state, loading: true }),
  ),
  on(
    PaginatedSurveyTaskActions.listPaginatedSurveyTasksSuccess,
    (state, { data }): PaginatedSurveyTaskState => ({
      ...state,
      ...data,
      ...data.pagination,
      total: Number(data.pagination?.total),
      loading: false,
    }),
  ),
  on(
    PaginatedSurveyTaskActions.listPaginatedSurveyTasksFailure,
    (state, { error }): PaginatedSurveyTaskState => ({
      ...state,
      error,
      loading: false,
    }),
  ),
);

export const paginatedSurveyTaskFeature = createFeature({
  name: paginatedSurveyTaskFeatureKey,
  reducer,
});
